import { 
  TableHead, 
  TableRow, 
  TableCell,
  TableSortLabel, 
  Box 
} from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import PropTypes from 'prop-types';

const MRTableHeaders = ({order, orderBy, onRequestSort, MRcols}) => {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead className='table-head-row'>
      <TableRow>
        {MRcols.map((headCell) => (
          headCell.showCol ? (
            <TableCell
              key={headCell.id}
              align='left'
              sortDirection={orderBy === headCell.id ? order : false}
              sx={{textTransform: 'uppercase'}}
              className={headCell?.headerClassName}
            >
              { headCell.sortable ?
                  <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : 'asc'}
                    onClick={createSortHandler(headCell.id)}
                  >
                    {headCell.label}
                    {orderBy === headCell.id ? (
                        <Box component="span" sx={visuallyHidden}>
                          {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                        </Box>
                    ) : null }
                  </TableSortLabel>
                :
                  <>
                    {headCell.label}
                  </>
              }
            </TableCell>
          ) : null 
        ))}
      </TableRow>
    </TableHead>
  );
}

MRTableHeaders.propTypes = {
  order: PropTypes.oneOf(['asc', 'desc']),
  orderBy: PropTypes.string,
  onRequestSort: PropTypes.func,
  MRcols: PropTypes.array
}

export default MRTableHeaders;